import { css, keyframes, styled } from 'styled-components';

import { visuallyHiddenCss } from 'components/VisuallyHidden/VisuallyHidden';
import { colors } from 'theme/theme';

export const OpenWebWidgetHolder = styled.div`
  &:not(:empty) + * {
    display: none;
  }

  &:empty {
    ${visuallyHiddenCss};
  }
`;

const attentionSeeker = keyframes`
  from, to {
    opacity: 0;
  }
  33% {
    opacity: .3;
  }
`;

export const OpenWebContainer = styled.div<{ $isFocused?: boolean }>`
  position: relative;

  ${(props) => {
    if (!props.$isFocused) return '';

    return css`
      &::before {
        content: '';
        position: absolute;
        inset: -4px;
        border-radius: 4px;
        z-index: -1;
        animation: ${attentionSeeker} 2s 0s ease-out both;
        background: ${colors.brandYellow};
      }
    `;
  }}
`;
